import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
	Modal,
	Label,
	Button,
	Icons,
	FullBar,
	Tabs,
	DialogHandler,
	TaskBarHandler,
} from "cakemail-ui-components/lib/react";
import fetchRoute from "../../utils/routes";
import { Translate, I18n } from "react-redux-i18n";
import PropTypes from "prop-types";
import Logos from "./containers/appBranding/Logos";
import Colours from "assets/js/scenes/brand/containers/appBranding/Colours";
import Fonts from "assets/js/scenes/brand/containers/Fonts";
import Illustrations from "assets/js/scenes/brand/containers/appBranding/Illustrations";
import Links from "assets/js/scenes/brand/containers/appBranding/Links";
import Settings from "assets/js/scenes/brand/containers/Settings";
import ListRedirection from "assets/js/scenes/brand/containers/ListRedirection";
import OptinEmails from "assets/js/scenes/brand/containers/OptinEmails";
import SmartEmailTemplates from "assets/js/scenes/brand/containers/SmartEmailTemplates";

import {
	setLocalBrand,
	setUnpublishedData,
} from "assets/js/scenes/brand/actions";
import deepcopy from "deepcopy";
import {
	addUnpublishedDataFromReset,
	applyLocalBrandToPreview,
	deleteUnpublishedDataFromPath,
	findDataInBrand,
	removeLocalBrandStorage,
	setStylesFromBrand,
} from "assets/js/scenes/brand/utils";
import BRAND, { USER_CHANNELS } from "assets/js/scenes/brand/const";
import CakeStore from "assets/js/store";
import { getBrandSuccess } from "assets/js/data/branding/actions";
import { setBrandHeadElements } from "assets/js/BrandWrapper";
import originalBrand from "assets/js/scenes/brand/data/originalBrand";
import {
	getUserBrandSDK,
	updateBrandService,
	updateUserBrandService,
} from "assets/js/services/brandingService";
import {
	SEGMENT_EVENTS,
	trackSegmentEvent,
} from "assets/js/const/SegmentEvents";
import { EmptyListingPage } from "assets/js/components/EmptyListingPage";
import { isPartner } from "utils/apiUtils";
import ManageAssetDialogContent from "assets/js/scenes/brand/components/BrandRepoSetup";
import { setUserBrand } from "assets/js/data/userBranding/actions";
import FetchingBrandRepo from "assets/js/scenes/brand/components/FetchingBrandRepo";
import {
	getSDKLink,
	getUrlQueryParam,
	isValidUrl,
	removeLegacyParameterByName,
} from "utils/urlUtils";
import { FEATURE_FLAG, hasFeatureFlag } from "utils/LimitsAndFeatures";

let totalCount = 0;
let totalErrors = 0;
export const Brand = (props) => {
	const isAPartner = isPartner();
	const [tab, setTab] = useState(
		isAPartner
			? "Logos"
			: props.location?.state?.returnTab
				? props.location.state.returnTab
				: "ListRedirection"
	);

	const publishlink = getUrlQueryParam("publishlink");

	const brandRepoUrl = props.brand?.client_config?.brand_repo?.url;
	let tabInTimeout = null;

	useEffect(() => {
		if (props.brand && props.localBrand == null) {
			const currentBrand = window.localStorage.getItem(
				props.accountId + "_" + BRAND.CURRENT_BRAND
			);
			const modifiedBrand = window.localStorage.getItem(
				props.accountId + "_" + BRAND.MODIFIED_BRAND
			);
			const unpublishedBrandChanges = window.localStorage.getItem(
				props.accountId + "_" + BRAND.UNPUBLISHED_CHANGES
			);

			//IF LOCAL BRAND IS NOT THE SAME AND CURRENT BRAND, REMOVE ALL LOCALSTORAGE

			if (currentBrand && modifiedBrand && unpublishedBrandChanges) {
				//IF LOCAL BRAND IS NOT ACTIVE
				try {
					window.localStorage.removeItem(
						props.accountId + "_" + BRAND.CURRENT_BRAND
					);
					window.localStorage.removeItem(
						props.accountId + "_" + BRAND.MODIFIED_BRAND
					);
					window.localStorage.removeItem(
						props.accountId + "_" + BRAND.UNPUBLISHED_CHANGES
					);

					props.setLocalBrand(null, JSON.parse(modifiedBrand));
					props.setUnpublishedData(JSON.parse(unpublishedBrandChanges));

					const parsedBrand = JSON.parse(currentBrand);

					if (isPartner()) {
						CakeStore.dispatch(getBrandSuccess(parsedBrand));
						setBrandHeadElements(parsedBrand);
					} else {
						CakeStore.dispatch(setUserBrand(parsedBrand));
					}
					setStylesFromBrand(parsedBrand);
				} catch (e) {
					window.location.reload();
				}
			} else {
				props.setLocalBrand(null, deepcopy(props.brand));
			}
		}

		if (props.brand) {
			// Those 2 events needs to be used while in the section and while previewing.
			// They are removed on mount to make sure they are not duplicated in the document
			// Or when we "discard and exit"
			window.removeEventListener("beforeunload", handleOnBrowserBeforeUnload);
			window.removeEventListener("unload", handleOnBrowserUnload);

			window.addEventListener("beforeunload", handleOnBrowserBeforeUnload);
			window.addEventListener("unload", handleOnBrowserUnload);

			if (
				!isAPartner &&
				publishlink &&
				isValidUrl(publishlink) &&
				brandRepoUrl !== publishlink
			) {
				const config = props.brand?.client_config || {};
				const pathNamePart = new URL(publishlink).pathname.split("/");
				updateBrand(null, {
					...props.brand,
					client_config: {
						...config,
						brand_repo: {
							url: publishlink,
							accountId: pathNamePart[2],
							brandId: pathNamePart[3],
						},
					},
				});
			} else if (brandRepoUrl && publishlink) {
				removeLegacyParameterByName("publishlink");
				props.history.replace(fetchRoute("brand"));
			}
		}
	}, [props.brand]);

	useEffect(() => {
		TaskBarHandler.hide();
		document.addEventListener("visibilitychange", tabActivated);
		return () => {
			props.setLocalBrand(null, null);
			props.setUnpublishedData({});

			window.removeEventListener("beforeunload", handleOnBrowserBeforeUnload);
			window.removeEventListener("unload", handleOnBrowserUnload);
			document.removeEventListener("visibilitychange", tabActivated);
		};
	}, []);

	function tabActivated() {
		clearTimeout(tabInTimeout);
		tabInTimeout = setTimeout(() => {
			if (
				!isPartner() &&
				CakeStore.getState().userBrand?.client_config?.brand_repo?.url
			) {
				getUserBrandSDK({
					url: CakeStore.getState().userBrand.client_config.brand_repo.url,
				});
			}
		}, 100);
	}

	function goToSDK(subPath = "", toConnect = false) {
		let sdkLink = getSDKLink(subPath, toConnect);

		if (!brandRepoUrl) {
			trackSegmentEvent(SEGMENT_EVENTS.BUTTON_CLICKED, {
				context: "Brand Repo Redirection Init",
				redirection: sdkLink,
			});
			DialogHandler.show({
				title: <Translate value="app-brand-brand-repo-intro-title" />,
				content: (
					<Translate
						value={"app-brand-brand-repo-intro-desc"}
						resellerName={props.resellerName}
					/>
				),
				primaryBtnText: <Translate value="app-brand-brand-repo-intro-B" />,
				primaryBtnOnClick: () => {
					trackSegmentEvent(SEGMENT_EVENTS.BUTTON_CLICKED, {
						context: "Brand Repo Redirection Init Confirmed",
						redirection: sdkLink,
					});
					window.location = sdkLink;
				},
				secondaryBtnText: <Translate value="app-general-cancel" />,
				secondaryBtnOnClick: () => {
					trackSegmentEvent(SEGMENT_EVENTS.BUTTON_CLICKED, {
						context: "Brand Repo Redirection Init Cancelled",
						redirection: sdkLink,
					});
					DialogHandler.hide();
				},
			});
		} else {
			if (
				window.localStorage.getItem("show-brand-manage-asset-dialog") ===
				"false"
			) {
				trackSegmentEvent(SEGMENT_EVENTS.BUTTON_CLICKED, {
					context: "Brand Repo Redirection",
					redirection: sdkLink,
					skipConfirmation: true,
				});
				window.location = sdkLink;
			} else {
				trackSegmentEvent(SEGMENT_EVENTS.BUTTON_CLICKED, {
					context: "Brand Repo Redirection",
					redirection: sdkLink,
				});
				DialogHandler.show({
					title: <Translate value="app-brand-brand-repo-manage-dialog-title" />,
					className: "doNotShowAgainBrandRepo",
					content: <ManageAssetDialogContent />,
					primaryBtnText: <Translate value="app-general-B-continue" />,
					primaryBtnOnClick: () => {
						trackSegmentEvent(SEGMENT_EVENTS.BUTTON_CLICKED, {
							context: "Brand Repo Redirection",
							redirection: sdkLink,
							skipConfirmation: false,
						});
						window.location = sdkLink;
					},
					secondaryBtnText: <Translate value="app-general-cancel" />,
					secondaryBtnOnClick: () => {
						trackSegmentEvent(SEGMENT_EVENTS.BUTTON_CLICKED, {
							context: "Brand Repo Redirection Cancelled",
							redirection: sdkLink,
							skipConfirmation: false,
						});
						DialogHandler.hide();
					},
				});
			}
		}
	}

	function onTabChange(e, item, index) {
		setTab(item.id);
	}

	function preview(url = null, returnTab = null) {
		trackSegmentEvent(SEGMENT_EVENTS.BUTTON_CLICKED, {
			context: "Brand Preview " + tab,
		});
		applyLocalBrandToPreview(
			props.brand,
			props.localBrand,
			props.unpublishedData,
			props.history,
			{ count: totalCount },
			props.setPreviewingBrand,
			url,
			{ returnTab: returnTab }
		);
	}

	function publish() {
		trackSegmentEvent(SEGMENT_EVENTS.BUTTON_CLICKED, {
			context: "Brand Publish",
		});
		DialogHandler.show({
			title: (
				<Translate value="app-brand-modal-publish-title" count={totalCount} />
			),
			content: (
				<p>
					<Translate
						value={
							isPartner()
								? "app-brand-modal-publish-desc"
								: "app-brand-modal-publish-desc-user"
						}
					/>
				</p>
			),
			primaryBtnText: <Translate value="app-general-publish" />,
			primaryBtnOnClick: updateBrand,
			secondaryBtnText: <Translate value="app-general-cancel" />,
			secondaryBtnOnClick: () => {
				trackSegmentEvent(SEGMENT_EVENTS.BUTTON_CLICKED, {
					context: "Brand Publish Cancelled",
				});
				DialogHandler.hide();
			},
		});
	}

	function discardAndExit() {
		function exit() {
			removeLocalBrandStorage();

			props.setLocalBrand(null, null);
			props.setUnpublishedData({});
			DialogHandler.hide();
			totalCount = 0;
			totalErrors = 0;

			window.removeEventListener("beforeunload", handleOnBrowserBeforeUnload);
			window.removeEventListener("unload", handleOnBrowserUnload);

			props.history.push(fetchRoute("dashboard"));
		}

		if (totalCount > 0) {
			trackSegmentEvent(SEGMENT_EVENTS.BUTTON_CLICKED, {
				context: "Brand Discard/Exit",
			});
			DialogHandler.show({
				title: <Translate value="app-general-discard-exit" />,
				content: (
					<p>
						<Translate value="app-brand-modal-discard-desc" />
					</p>
				),
				primaryBtnText: <Translate value="app-general-discard-exit" />,
				primaryBtnOnClick: () => {
					trackSegmentEvent(SEGMENT_EVENTS.BUTTON_CLICKED, {
						context: "Brand Discard/Exit Confirmed",
					});
					exit();
				},
				secondaryBtnText: <Translate value="app-general-cancel" />,
				secondaryBtnOnClick: () => {
					trackSegmentEvent(SEGMENT_EVENTS.BUTTON_CLICKED, {
						context: "Brand Discard/Exit Cancelled",
					});
					DialogHandler.hide();
				},
			});
		} else {
			trackSegmentEvent(SEGMENT_EVENTS.BUTTON_CLICKED, {
				context: "Brand Exit",
			});
			exit();
		}
	}

	function updateBrand(btnRef = null, forcedBrand = null) {
		trackSegmentEvent(SEGMENT_EVENTS.BUTTON_CLICKED, {
			context: "Brand Publish Confirmed",
		});

		if (btnRef) {
			btnRef.current.startAnimation();
		}

		let brand = deepcopy(forcedBrand ? forcedBrand : props.localBrand);
		delete brand.config;

		function success(data) {
			removeLegacyParameterByName("publishlink");
			if (
				data.data.client_config?.brand_repo?.url !==
				props.brand.client_config?.brand_repo?.url
			) {
				getUserBrandSDK(
					{ url: data.data.client_config.brand_repo?.url },
					() => {},
					(msg) => {
						props.history.push(fetchRoute("dashboard"));
						DialogHandler.show({
							type: "error",
							title: (
								<Translate
									value={
										msg ? msg : "app-brand-settings-brand-repo-fetch-error"
									}
								/>
							),
						});
					}
				);
			}

			trackSegmentEvent(SEGMENT_EVENTS.BRAND_UPDATED, {
				changes: totalCount,
			});

			props.setLocalBrand(null, data.data);
			props.setUnpublishedData({});

			setStylesFromBrand(data.data);

			if (isAPartner) {
				CakeStore.dispatch(getBrandSuccess(data.data));
			} else {
				CakeStore.dispatch(setUserBrand(data.data));
			}

			if (btnRef) {
				btnRef.current.reset();
			}
			DialogHandler.hide();
			DialogHandler.show({
				type: "success",
				title: <Translate value="app-brand-upload-success" />,
			});
		}

		function failure(msg) {
			if (btnRef) {
				btnRef.current.reset();
			}
			DialogHandler.hide();
			DialogHandler.show({
				type: "error",
				title: <Translate value={msg ? msg : "app-brand-upload-error"} />,
			});
		}

		if (isAPartner) {
			updateBrandService(
				brand,
				(data) => {
					success(data);
				},
				(msg) => {
					failure(msg);
				}
			);
		} else {
			updateUserBrandService(
				{ brand: brand, id: props.accountId },
				(data) => {
					success(data);
				},
				(msg) => {
					failure(msg);
				}
			);
		}
	}

	function resetTabData(path, incFilter = []) {
		//TODO Fill the unpublished changes on things that got reset
		let originalBrandData = { ...findDataInBrand(path, originalBrand) };
		let currentBrandData = { ...findDataInBrand(path, props.brand) };

		let fullPath = path.split(".");
		//Reference to what needs to be overridden
		let localBrandSchema = findDataInBrand(path, props.localBrand, true);
		let localBrandSchemaObj = findDataInBrand(path, props.localBrand);

		if (incFilter.length > 0) {
			incFilter.forEach((filteredKey) => {
				//reference functions
				deleteUnpublishedDataFromPath(
					path + "." + filteredKey,
					props.unpublishedData
				);
				addUnpublishedDataFromReset(
					path,
					props.unpublishedData,
					localBrandSchemaObj,
					currentBrandData,
					originalBrandData,
					filteredKey
				);
			});

			localBrandSchema[fullPath[fullPath.length - 1]] = localBrandSchemaObj;
		} else {
			//reference functions
			deleteUnpublishedDataFromPath(path, props.unpublishedData);
			addUnpublishedDataFromReset(
				path,
				props.unpublishedData,
				localBrandSchemaObj,
				currentBrandData,
				originalBrandData
			);

			localBrandSchema[fullPath[fullPath.length - 1]] = originalBrandData;
		}

		props.setLocalBrand(null, deepcopy(props.localBrand));
		props.setUnpublishedData(deepcopy(props.unpublishedData));

		DialogHandler.hide();
	}

	function fetchUnpubCount(path) {
		let count = 0;
		let errors = 0;
		for (const key in props.unpublishedData) {
			if (key.includes(path)) {
				if (props.unpublishedData[key].valid === "valid") {
					count++;
				} else {
					errors++;
				}
			}
		}

		totalCount += count;
		totalErrors += errors;
		return { count, errors };
	}

	function handleOnBrowserBeforeUnload(e) {
		if (totalCount > 0) {
			// Cancel the event
			e.preventDefault(); // If you prevent default behavior in Mozilla Firefox prompt will always be shown
			// Chrome requires returnValue to be set
			e.returnValue = "";
		}
	}

	function handleOnBrowserUnload() {
		removeLocalBrandStorage();
	}

	/*
	 * *****************
	 * Modal tab labels
	 * *****************
	 */
	function simpleLabel(countObject) {
		return (
			countObject > 0 && (
				<Label shapeStyle="fill" text={countObject} type="count" />
			)
		);
	}

	function complexLabel(countObject) {
		return countObject.errors > 0 ? (
			<Label
				colorTheme="red"
				shapeStyle="fill"
				text={countObject.errors}
				type="count"
			/>
		) : (
			<>
				{countObject.count > 0 && (
					<Label shapeStyle="fill" text={countObject.count} type="count" />
				)}
			</>
		);
	}

	/*
	 * *****************
	 * Variables
	 * *****************
	 */
	//reset count on render
	totalCount = 0;
	totalErrors = 0;
	//next 3 doesnt have validation so they cant count has errors
	const countLogos =
		fetchUnpubCount("images.logo").count +
		fetchUnpubCount("images.injected_logo").count +
		fetchUnpubCount("images.favicon").count +
		fetchUnpubCount("name").count;
	const countFonts = fetchUnpubCount("theme.fonts").count;
	const countIllustrations = fetchUnpubCount("images.ill").count;
	//Can have errors
	const countColors = fetchUnpubCount("theme.base");
	const countLinks = fetchUnpubCount("url");
	const countSettings = fetchUnpubCount("client_config");
	const countListRedirection = fetchUnpubCount(USER_CHANNELS.LIST_REDIRECTION);
	const countOptinEmails = fetchUnpubCount(USER_CHANNELS.OPTIN_EMAILS);
	const countSmartEmailTemplates = fetchUnpubCount(
		USER_CHANNELS.SMART_EMAIL_TEMPLATES
	);

	//Tab Id And React Containers
	const containers = {
		Logos,
		Colours,
		Fonts,
		Illustrations,
		Links,
		Settings,
		ListRedirection,
		OptinEmails,
		SmartEmailTemplates,
	};
	const TabComponent = containers[tab];
	const isMyBrand =
		"" + props.brand?.config?.partner_account_id === "" + props.accountId;

	/*
	 * *****************
	 * Modal top bar
	 * *****************
	 */

	const fullbarRightElements = [];
	if (!isAPartner) {
		fullbarRightElements.push(
			<Button
				shapeStyle="stroke"
				colorTheme="grey"
				onClick={() => {
					goToSDK();
				}}
				text={<Translate value="app-brand-repo-manage-B" />}
			/>
		);
	}

	const topBarLeft = [
		<p className="h7">
			<Translate value="app-brand-modal-title" />
		</p>,
	];

	if (totalErrors > 0) {
		topBarLeft.push(
			<Label
				colorTheme="red"
				shapeStyle="fill"
				text={
					<Translate
						value="app-brand-modal-total-changes-errors"
						count={totalErrors}
					/>
				}
			/>
		);
	} else if (totalCount > 0) {
		topBarLeft.push(
			<Label
				shapeStyle="fill"
				text={
					<Translate value="app-brand-modal-total-changes" count={totalCount} />
				}
			/>
		);
	}

	const topBarRight = [
		<Button
			colorTheme="grey"
			text={
				<>
					{" "}
					{totalCount > 0 ? (
						<>
							<Icons name="glyph-trash" />{" "}
							<Translate value="app-general-discard-exit" />
						</>
					) : (
						<Translate value="app-general-B-exit" />
					)}
				</>
			}
			onClick={discardAndExit}
		/>,
	];

	topBarRight.unshift(
		<Button
			disabled={totalErrors > 0 || totalCount === 0}
			text={
				<>
					{" "}
					<Icons name="glyph-cloud-upload" />{" "}
					<Translate value="app-general-publish" />
				</>
			}
			onClick={publish}
		/>
	);

	if (isAPartner) {
		topBarRight.unshift(
			<Button
				disabled={totalErrors > 0 || totalCount === 0}
				shapeStyle="stroke"
				text={
					<>
						{" "}
						<Icons name="glyph-show" />{" "}
						<Translate value="app-general-preview" />
					</>
				}
				onClick={preview}
			/>
		);
	}

	/*
	 * *****************
	 * Modal content
	 * *****************
	 */
	let tabsContent = isAPartner
		? [
			{
				id: "Logos",
				content: (
					<>
						<Translate value="app-brand-modal-tabs-logo" />
						{simpleLabel(countLogos)}
					</>
				),
			},
			{
				id: "Colours",
				content: (
					<>
						<Translate value="app-brand-modal-tabs-colours" />
						{complexLabel(countColors)}
					</>
				),
			},
			/*{id : "Fonts", content : <>
			<Translate value="app-brand-modal-tabs-fonts"/>
			{countFonts > 0 &&
			<Label
				shapeStyle="fill"
				text={countFonts}
				type="count"
			/>
			}
		</>},*/
			{
				id: "Illustrations",
				content: (
					<>
						<Translate value="app-brand-modal-tabs-illustrations" />
						{simpleLabel(countIllustrations)}
					</>
				),
			},
			{
				id: "Links",
				content: (
					<>
						<Translate value="app-brand-modal-tabs-links" />
						{complexLabel(countLinks)}
					</>
				),
			},
			{
				id: "Settings",
				content: (
					<>
						<Translate value="app-brand-modal-tabs-settings" />
						{complexLabel(countSettings)}
					</>
				),
			},
		  ]
		: props.accountCreationDate >= 1676661511
			? [
				{
					id: "ListRedirection",
					content: (
						<>
							<Translate value="app-brand-modal-tabs-list-redirection" />
							{complexLabel(countListRedirection)}
						</>
					),
				},
				{
					id: "OptinEmails",
					content: (
						<>
							<Translate value="app-brand-modal-tabs-optin-emails" />
							{complexLabel(countOptinEmails)}
						</>
					),
				},
		  ]
			: [
				{
					id: "ListRedirection",
					content: (
						<>
							<Translate value="app-brand-modal-tabs-list-redirection" />
							{complexLabel(countListRedirection)}
						</>
					),
				},
		  ];

	if (!isAPartner && hasFeatureFlag(FEATURE_FLAG.SMART_TEMPLATE_ENABLED)) {
		tabsContent.push({
			id: "SmartEmailTemplates",
			content: (
				<>
					<Translate value="app-brand-modal-tabs-smart-templates" />
					{complexLabel(countSmartEmailTemplates)}
				</>
			),
		});
	}

	/*
	 * *****************
	 * Modal Render
	 * *****************
	 */

	return (
		<Modal
			id="brand-modal"
			topBarLeft={topBarLeft}
			topBarRight={topBarRight}
			type={"ext-1"}
			content={
				<>
					{((isAPartner && props.brand) ||
						(brandRepoUrl && props.userBrandSDK) ||
						(!brandRepoUrl && props.brand && !publishlink)) && (
						<>
							<FullBar
								className="titleRow"
								left={
									<h3>
										<Translate value="app-brand-modal-content-title" />
									</h3>
								}
								right={fullbarRightElements}
							/>

							{isMyBrand && props.localBrand != null && (
								<>
									<Tabs
										onClick={onTabChange}
										selectedTab={tab}
										contents={tabsContent}
									/>
									<TabComponent
										resetTabData={resetTabData}
										preview={preview}
										goToSDK={goToSDK}
									/>
								</>
							)}

							{!isMyBrand && (
								<EmptyListingPage
									path={fetchRoute("dashboard")}
									title={<Translate value="app-general-no-results" />}
									image={props.illEmptyListing}
								/>
							)}
						</>
					)}

					{(props.brand == null ||
						(brandRepoUrl && props.userBrandSDK == null) ||
						(publishlink && !brandRepoUrl)) && <FetchingBrandRepo />}
				</>
			}
		/>
	);
};

Brand.propTypes = {
	logo: PropTypes.string,
	history: PropTypes.object,
	setLocalBrand: PropTypes.func,
	localBrand: PropTypes.object,
	brand: PropTypes.object,
	userBrandSDK: PropTypes.object,
	unpublishedData: PropTypes.object,
	setUnpublishedData: PropTypes.func,
	setPreviewingBrand: PropTypes.func,
	accountId: PropTypes.string,
	illEmptyListing: PropTypes.string,
	resellerName: PropTypes.string,
};

Brand.defaultProps = {};

export default withRouter(
	connect(
		(state) => {
			return {
				accountCreationDate: state.global.account.created_on,
				accountId: state.global.account.id,
				logo: state.brand?.images["logo"],
				brand: isPartner() ? state.brand : state.userBrand,
				localBrand: state.localBrand.data,
				illEmptyListing: state.brand.images["ill-empty-listing"],
				userBrandSDK: state.userBrandSDK,
				unpublishedData: state.localBrand.unpublishedData,
				resellerName: state.brand?.name,
			};
		},
		(dispatch) =>
			bindActionCreators(
				{
					setLocalBrand,
					setUnpublishedData,
				},
				dispatch
			)
	)(Brand)
);
